import { useContext } from 'react';
import { GroupContext } from './group-context';

const useGroupContext = () => useContext(GroupContext);

export default useGroupContext;
